export default "__VITE_ASSET__30bd8ff7__"